import fieldType from '@/enums/fieldType'
import vuei18n from '@/plugins/vuei18n'
import schemaType from "@/enums/schemaType";
import BaseAdapter from "@/plugins/BaseAdapter";


const testHeaders = [
    {
        text: vuei18n.t('test.passed'),
        value: 'passed',
        type: fieldType.PERMAMENT,
        sortable: false
    },
    {
        text: vuei18n.t('test.score'),
        value: 'score',
        type: fieldType.PERMAMENT,
        sortable: false
    },
    {
        text: vuei18n.t('agency.agency'),
        value: 'agency',
        type: fieldType.PERMAMENT,
        sortable: true
    },
    {
        text: vuei18n.t('base.lang'),
        value: 'lang',
        type: fieldType.PERMAMENT,
        sortable: false
    },
]


// TODO
export default class FormAdapter extends BaseAdapter{
  constructor (schema, showFullName){
    super()
    this.fields = schema.fields
    this.confirmation = schema.confirmation
    this.headers = []
    this.records = []
    this.type = schema.type
    this.schema = schema
    this.showFullName = showFullName
    this.setUpHeaders()
  }

  addAdditionalHeaders(){
    if(this.type == schemaType.TEST ){
      testHeaders.forEach(header =>{
        this.headers.push(header)
      })
    }

    if (this.confirmation) {
      this.headers.push({ text: vuei18n.t('form.confirmation'), value: 'confirmation', type: fieldType.CONFIRMATION, sortable: false })
    }
  }

  setTestValues(record, form){
    Object.assign(record, { score : form.score })
    Object.assign(record, { agency : this.agencyName(form.created_by) })
    Object.assign(record, { lang : form.lang })
    Object.assign(record, {passed: form.score >= this.schema.min_score ? vuei18n.t('test.passed') : vuei18n.t('test.failed')})
  }

  setAdditionalValues(record, form) {
      if (this.confirmation) {
          Object.assign(record, { confirmation: { confirmed_by: this.username(form.confirmed_by), confirmed_at: form.confirmed_at } })
      }

      if(this.type ==schemaType.TEST ){
          this.setTestValues(record, form)
      }
  }
}
